import { useQuestOptions } from '../../../Hooks/useQuestOptions';
import { WorksheetComponent, WorksheetComponentProps, WorksheetComponentType } from './WorksheetComponent.Component';

export function TextRow(props: WorksheetComponentProps) {
  return <WorksheetComponent {...props} componentType={WorksheetComponentType.TEXT} />;
}
export function InputRow(props: WorksheetComponentProps) {
  return <WorksheetComponent {...props} componentType={WorksheetComponentType.SINGLE_LINE} />;
}
export function PasswordRow(props: WorksheetComponentProps) {
  return <WorksheetComponent {...props} componentType={WorksheetComponentType.PASSWORD} />;
}
export function TextAreaRow(props: WorksheetComponentProps) {
  return <WorksheetComponent {...props} componentType={WorksheetComponentType.TEXT_AREA} />;
}
export function DropdownRow(props: WorksheetComponentProps) {
  return <WorksheetComponent {...props} componentType={WorksheetComponentType.DROPDOWN} />;
}
export function QuestDropdownRow(props: WorksheetComponentProps) {
  const options = useQuestOptions()
  return <WorksheetComponent {...props} componentType={WorksheetComponentType.DROPDOWN} options={options} />;
}
export function MultiLineRow(props: WorksheetComponentProps) {
  return <WorksheetComponent {...props} componentType={WorksheetComponentType.MULTI_LINE} />;
}
export function SwitchRow(props: WorksheetComponentProps) {
  return <WorksheetComponent {...props} componentType={WorksheetComponentType.SWITCH} />;
}
export function SectionHeader(props: WorksheetComponentProps) {
  return <WorksheetComponent {...props} componentType={WorksheetComponentType.SECTION_HEADER} />;

}
export function Section(props: WorksheetComponentProps) {
  return <WorksheetComponent {...props} componentType={WorksheetComponentType.SECTION} />;

}

export function PageHeader(props: WorksheetComponentProps) {
  return <WorksheetComponent {...props} componentType={WorksheetComponentType.PAGE_HEADER} />;

}
export function Indent(props: WorksheetComponentProps) {
  return <WorksheetComponent {...props} componentType={WorksheetComponentType.INDENT} />;

}
